/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Profile Actions
 */

// Constants
import {
  GET_ALL_PROFILES,
  CREATE_PROFILE,
  UPDATE_PROFILE,
  GET_PROFILE_BY_ID,
  DELETE_PROFILE_BY_ID
} from './constants';

/**
 * Call process to get all profiles list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PROFILES
 */
export const getProfilesArray = (data, callback) => ({
  type: GET_ALL_PROFILES,
  payload: { data },
  callback
});

/**
 * Call process to get profile by id
 * @param  { object } data - Profile Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getProfileById = (data, callback) => ({
  type: GET_PROFILE_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create profile
 * @param  { object } data - Profile Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_PROFILE
 */
export const createProfile = (data, callback) => ({
  type: CREATE_PROFILE,
  payload: { data },
  callback
});

/**
 * Call process to update profile
 * @param  { object } data - Profile Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_PROFILE
 */
export const updateProfile = (data, callback) => ({
  type: UPDATE_PROFILE,
  payload: { data },
  callback
});

/**
 * Call process to delete profile
 * @param  { object } data - Profile Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_PROFILE_BY_ID
 */
export const deleteProfileById = (data, callback) => ({
  type: DELETE_PROFILE_BY_ID,
  payload: { data },
  callback
});
